exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container__a6pZA{background-color:#eee;padding:16px 0;-webkit-box-flex:1;-ms-flex:1;flex:1}", "", {"version":3,"sources":["/opt/build/repo/src/components/ChatSearchResultsPage/ChatSearchResultsPage.styles.scss"],"names":[],"mappings":"AAEA,kBACE,sBACA,eACA,mBAAA,WAAA,MAAO,CACR","file":"ChatSearchResultsPage.styles.scss","sourcesContent":["@import '../../variables';\n\n.container {\n  background-color: $gray-200;\n  padding: 16px 0;\n  flex: 1;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container__a6pZA"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/ChatSearchResultsPage/ChatSearchResultsPage.styles.scss
// module id = BS4A
// module chunks = 0